import Tastet from '../tastet.js';

const CLASSES = {
  IS_VISIBLE: 'is-visible',
};

const STATES = {
  ALL_OPEN: 'all-open',
};

export default class Reveal extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      target: '',
      parent: null,
      count: 1,
    });

    this.$parent = this.$(data.parent);
    this.$parent = this.$parent.length ? this.$parent : this.$element;
    this.$targets = this.$parent.find(data.target);
  }

  addEvents() {
    this.$more && this.on(this.$more, 'click', this.more_onClick);
    this.$less && this.on(this.$less, 'click', this.less_onClick);
    this.$show && this.on(this.$show, 'click', this.show_onClick);
    this.$hide && this.on(this.$hide, 'click', this.hide_onClick);
    this.$toggle && this.on(this.$toggle, 'click', this.toggle_onClick);
  }

  render() {
    if (this.isOpen()) {
      this.state(STATES.ALL_OPEN, true);
    } else {
      this.state(STATES.ALL_OPEN, false);
    }
  }

  // private  --------------------------------------------------------------------------------------------------------

  // events ----------------------------------------------------------------------------------------------------------
  more_onClick(e) {
    e.stop();
    this.show(this.data.count);
  }

  less_onClick(e) {
    e.stop();
    this.hide(this.data.count);
  }

  show_onClick(e) {
    e.stop();
    this.show();
  }

  hide_onClick(e) {
    e.stop();
    this.hide();
  }

  toggle_onClick(e) {
    e.stop();

    if (this.isOpen()) {
      this.hide();
    } else {
      this.show();
    }
  }

  // methods ---------------------------------------------------------------------------------------------------------
  show(count) {
    var $targets = !count ? this.$targets : this.$targets.not('.' + CLASSES.IS_VISIBLE).first(count);
    $targets.addClass(CLASSES.IS_VISIBLE);

    this.scan($targets, { lazy: true });

    this.render();
  }

  hide(count) {
    var $targets = !count ? this.$targets : this.$targets.filter('.' + CLASSES.IS_VISIBLE).last(count);
    $targets.removeClass(CLASSES.IS_VISIBLE);
    this.render();
  }

  isOpen() {
    return !this.$targets.not('.' + CLASSES.IS_VISIBLE).length;
  }
}
